import React, {createContext, useContext, useReducer} from 'react';
import PropTypes from 'prop-types';
import {createPortal} from 'react-dom';

export const InsightsContext = createContext({});

export function useInsights() {
    return useContext(InsightsContext);
}

const actions = {
    setAbortion: 'setAbortion',
    setPromptFigure: 'setPromptFigure',
    setError: 'setError',
    setRefresh: 'setRefresh',
    setRequestNewData: 'setRequestNewData',
    setRequestingInsights: 'setRequestingInsights',
    setReplying: 'setReplying',
    setAnswer: 'setAnswer',
    setQuestionText: 'setQuestionText',
    setCurrentText: 'setCurrentText',
    addTextChunk: 'addTextChunk',
    setDisplayText: 'setDisplayText',
};

function insightsReducer(state, action) {
    switch (action.type) {
        case actions.setAbortion:
            return {...state, abortion: action.payload};
        case actions.setPromptFigure:
            return {...state, promptFigure: action.payload};
        case actions.setError:
            return {...state, error: action.payload};
        case actions.setRefresh:
            return {...state, refresh: action.payload};
        case actions.setRequestNewData:
            return {...state, requestNewData: action.payload};
        case actions.setRequestingInsights:
            return {...state, requestingInsights: action.payload};
        case actions.setReplying:
            return {...state, replying: action.payload};
        case actions.setAnswer:
            return {...state, answer: action.payload};
        case actions.setQuestionText:
            return {...state, questionText: action.payload};
        case actions.setCurrentText:
            return {...state, currentText: action.payload};
        case actions.addTextChunk:
            return {...state, currentText: state.currentText + action.payload};
        case actions.setDisplayText:
            return {...state, displayText: action.payload};
        default:
            return {...state};
    }
}

const createAction = (dispatch, type) => (payload) => dispatch({type, payload});

export function createInsightsContext() {
    const [state, dispatch] = useReducer(insightsReducer, {
        abortion: null,
        promptFigure: null,
        error: null,
        refresh: false,
        requestNewData: false,
        requestingInsights: false,
        replying: '',
        answer: '',
        questionText: '',
        currentText: '',
        displayText: '',
    });

    const setAbortion = createAction(dispatch, actions.setAbortion);
    const setPromptFigure = createAction(dispatch, actions.setPromptFigure);
    const setError = createAction(dispatch, actions.setError);
    const setRefresh = createAction(dispatch, actions.setRefresh);
    const setRequestNewData = createAction(dispatch, actions.setRequestNewData);
    const setRequestingInsights = createAction(
        dispatch,
        actions.setRequestingInsights
    );
    const setReplying = createAction(dispatch, actions.setReplying);
    const setAnswer = createAction(dispatch, actions.setAnswer);
    const setQuestionText = createAction(dispatch, actions.setQuestionText);
    const setCurrentText = createAction(dispatch, actions.setCurrentText);
    const addTextChunk = createAction(dispatch, actions.addTextChunk);
    const setDisplayText = createAction(dispatch, actions.setDisplayText);

    return {
        state,
        dispatch,
        setAbortion,
        setPromptFigure,
        setError,
        setRefresh,
        setRequestNewData,
        setRequestingInsights,
        setReplying,
        setAnswer,
        setQuestionText,
        setCurrentText,
        addTextChunk,
        setDisplayText,
    };
}

export const InsightsProvider = (props) => {
    const {gdref} = props;
    if (!gdref.current) {return null;}
    const context = createInsightsContext();
    return createPortal(
        <InsightsContext.Provider value={context}>
            {props.children}
        </InsightsContext.Provider>,
        gdref.current,
    )
};

InsightsProvider.propTypes = {
    children: PropTypes.node,
    gdref: PropTypes.any,
};
